import React from 'react';
import { Player } from '@lottiefiles/react-lottie-player';
import '@lottiefiles/lottie-player';
import { create } from '@lottiefiles/lottie-interactivity';
import lottieJson from './carbonvert.json';

class Lottie extends React.Component {
 constructor(props) {
    super(props);
    this.myRef = React.createRef(); // 1. create a reference for the lottie player
  }
  componentDidMount() {
    // 3. listen for player load. see lottie player repo for other events
    this.myRef.current.addEventListener('load', function (e) {
      // 4. configure the interactivity library
      create({
        mode: 'scroll',
        player: '#firstLottie',
        container: "#animationwrapper",
        actions: [
          {
            visibility: [0, 0.2],
            type: 'stop',
            frames: [0],
          },
          {
            visibility: [0.2, 0.9],
            type: 'seek',
            frames: [0, 400],
          },
        ],
      });
    });
  }
  render() {
    return (
      // <div class="h-[750px] h-96">
        <lottie-player
          ref={this.myRef} // 2. set the reference for the player
          id="firstLottie"
          // controls
          mode="normal"
          src="https://assets1.lottiefiles.com/packages/lf20_7hehzmwn.json"
          style={{ width: 'auto' }}
        ></lottie-player>
      // </div>
    );
  }
}

export default Lottie;

